import { render } from "./LbrxLoginLogo.vue?vue&type=template&id=f60828d6&scoped=true"
import script from "./LbrxLoginLogo.vue?vue&type=script&lang=js"
export * from "./LbrxLoginLogo.vue?vue&type=script&lang=js"

import "./LbrxLoginLogo.vue?vue&type=style&index=0&id=f60828d6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f60828d6"]])

export default __exports__